// initial state
const state = {
    user: null
};

// getters
const getters = {
    getUser: state => {
        return state.user;
    },

};

// actions
const actions = {
    authUser({commit}) {
        commit('setUser', {id: 1, name: 'Admin'});
        //this.$router.replace(this.$route.query.redirect || '/questionnaire');
    }
};

// mutations
const mutations = {
    setUser (state, user) {
        state.user = user;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}